import React from 'react';
import { MoreHoriz } from '@mui/icons-material';
import * as S from './Settings.styles';
import { Variant } from './Settings.styles';

interface SettingsProps {
  active: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  dataCy?: string;
  variant?: Variant;
}

export const Settings: React.FC<SettingsProps> = ({ active, dataCy = 'tdm', variant = 'plain', ...rest }) => {
  return (
    <S.Div $active={active} $variant={variant} {...rest} id="stngs" data-cy={dataCy}>
      <MoreHoriz />
    </S.Div>
  );
};
